/**
 * Schémas pour l'espace entreprise (Phase 3).
 */
import { z } from 'zod';
export const entrepriseProfileSchema = z.object({
    raisonSociale: z.string().trim().min(2).max(200),
    description: z.string().trim().max(2000).optional().or(z.literal('')),
    ville: z.string().trim().max(100).optional().or(z.literal('')),
    siteWeb: z.string().trim().url().optional().or(z.literal('')),
    // Vague A — réseau social pro pour visibilité / vérification.
    linkedinUrl: z.string().trim().url().max(500).optional().or(z.literal('')),
    contactPrenom: z.string().trim().min(1).max(100),
    contactNom: z.string().trim().min(1).max(100),
    contactFonction: z.string().trim().min(1).max(150).optional().or(z.literal('')),
    contactTelephone: z
        .string()
        .trim()
        .regex(/^\+?[\d\s().-]{6,20}$/)
        .optional()
        .or(z.literal('')),
    sectorIds: z.array(z.string().uuid()).max(13).default([]),
    targetLevels: z.array(z.enum(['L3', 'M1', 'M2'])).max(3).default([]),
});
/**
 * Helper : accepte un array OU une valeur unique (cas typique d'une
 * query URL `?levels=M1`) et la convertit en array. Express n'enrobe
 * pas automatiquement les single values en array.
 */
const asArray = (item) => z.preprocess((v) => (v === undefined || v === '' ? undefined : Array.isArray(v) ? v : [v]), z.array(item).optional());
export const candidatSearchSchema = z.object({
    formationCodes: asArray(z.string()),
    sectorIds: asArray(z.string().uuid()),
    levels: asArray(z.enum(['L3', 'M1', 'M2'])),
    langues: asArray(z.string()),
    mobilites: asArray(z.string()),
    q: z.string().trim().max(120).optional(),
    // Vague D — Nouveaux filtres exploitant les préférences candidat (Vague C).
    // Tous optionnels. Plusieurs valeurs = OR logique.
    availabilityTypes: asArray(z.enum(['immediate', 'in_weeks', 'end_of_studies', 'saison_ete', 'saison_hiver'])),
    jobTypes: asArray(z.enum([
        'stage',
        'alternance',
        'apprentissage',
        'cdd',
        'cdi',
        'interim',
        'extra',
        'freelance',
        'autre',
    ])),
    // Horaires que le candidat doit accepter (filtre AND : tous les horaires
    // de la liste doivent être présents dans acceptedSchedules).
    schedulesRequired: asArray(z.string().trim().max(40)),
    // Type d'établissement que le candidat dit chercher. Filtre OR.
    establishmentKinds: asArray(z.string().trim().max(40)),
    // Permis B requis : si true, on filtre les candidats sans permis B.
    permisBRequired: z.coerce.boolean().optional(),
    // Mobilité minimum requise. Le candidat doit avoir au moins ce niveau.
    // Ordre : local < km50 < km100 < km200 < regional < national < international
    mobilityMinRequired: z
        .enum(['local', 'km50', 'km100', 'km200', 'regional', 'national', 'international'])
        .optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(50).default(20),
});
export const savedSearchSchema = z.object({
    name: z.string().trim().min(1).max(80),
    criteria: z.record(z.unknown()),
});
//# sourceMappingURL=entreprise.js.map